import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const SiteTypeSelector = ({ options, onChange, value }) => {
    return (
        <FormControl fullWidth>
            <InputLabel id="site-type-select-label">Type</InputLabel>
            <Select
                labelId="site-type-select-label"
                id="site-type-select"
                value={value}
                label="Type"
                onChange={onChange}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option}
                        value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default SiteTypeSelector;